import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';
import { assetUrl } from '@sparta.targeted-content.helpers/targeted-content-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-sticky-full-width=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFullWidth") : stack1), depth0))
    + " ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div id=\"stickyNav\" class=\"sticky spa-sticky\"\r\n  "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"stickyFullWidth") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":3,"column":90}}})) != null ? stack1 : "")
    + "\">\r\n  <div class=\"nav-container\">\r\n    <div class=\"logo-container\">\r\n      <a href=\"/\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"logoId") : stack1), depth0))
    + "\" data-bactmln=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"logoDataBactmln") : stack1), depth0))
    + "\">\r\n        <img src=\""
    + container.escapeExpression((lookupProperty(helpers,"assetUrl")||(depth0 && lookupProperty(depth0,"assetUrl"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"logo") : stack1),{"name":"assetUrl","hash":{},"data":data,"loc":{"start":{"line":7,"column":18},"end":{"line":7,"column":42}}}))
    + "\" alt=\"\">\r\n      </a>\r\n    </div>\r\n    <div>\r\n      <a\r\n        class=\"login show-for-medium-up\"\r\n        href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"loginLink") : stack1), depth0))
    + "\"\r\n        id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"loginLinkId") : stack1), depth0))
    + "\"\r\n        data-bactmln=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"loginDataBactmln") : stack1), depth0))
    + "\"\r\n      >\r\n        <span>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"button1") : stack1), depth0))
    + "</span>\r\n      </a>\r\n      <div>\r\n        <button class=\"burger-button show-for-small-only\"></button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"closed closing burger-drawer show-for-small-only\">\r\n  <a\r\n    class=\"hidden\"\r\n    href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"loginLink") : stack1), depth0))
    + "\"\r\n    id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"loginLinkIdSmall") : stack1), depth0))
    + "\"\r\n    data-bactmln=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"loginDataBactmln") : stack1), depth0))
    + "\"\r\n  >\r\n    "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"sticky") : depth0)) != null ? lookupProperty(stack1,"button2") : stack1), depth0))
    + "\r\n  </a>\r\n</div>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.merrill-homepage.modules/sticky-nav-legacy-module",
  "version": "1.0.0",
  "id": "stickyNavLegacyModule",
  "containerID": "merrillHomepageStickyNavLegacyModule",
  "moduleName": "merrill-homepage-sticky-nav-legacy-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "sticky-nav-legacy-module",
  "data": {
    "init": "stickyNavLegacyModule",
    "options": {
      "eyebrowBanner": "{{json eyebrowBanner}}"
    }
  },
  "moduleParams": [{
    "name": "stickyFullWidth",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "This parameter determines the width of the sticky nav"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        assetUrl
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    assetUrl
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.5",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.targeted-content.helpers/targeted-content-helper": "^1.0.0"
  },
  "stores": []
};

// this file was created by default via Transmogrify

/**
 * @export
 * @class stickyNavLegacyModule
 * @extends {Module}
 */
class stickyNavLegacyModule extends Module {
  /**
   * Creates an instance of stickyNavLegacyModule.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof stickyNavLegacyModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.stickyNav = document.getElementById('stickyNav');
  }

  /**
   * @returns {void}
   */
  init() {
    this.target = this.settings.target;
    this.toggle = this.target.querySelector('.burger-button');
    this.drawer = this.target.querySelector('.burger-drawer');
    this.link = this.target.querySelector('.burger-drawer a');
    this.toggle.addEventListener('click', e => {
      e.currentTarget.classList.toggle('open');
      this.drawer.classList.remove('closed');
      this.drawer.classList.toggle('opened');
      this.drawer.classList.toggle('closing');

      // Removes the link from DOM after the drawer is closed instead
      // of during the animation sequence
      if (this.drawer.classList.contains('closing')) {
        setTimeout(() => {
          this.link.classList.add('hidden');
        }, '400');
      } else {
        this.link.classList.remove('hidden');
      }
    });

    // Prevents some jumping caused by the closing animation
    window.addEventListener('resize', () => {
      this.drawer.classList.add('closed');
    });
    this.eyebrowBanner = this.settings.eyebrowBanner;
    if (this.eyebrowBanner) {
      this.Events.pub('eyeBrowEvent', this.eyebrowBanner);
    }
    window.addEventListener('scroll', _.throttle(() => {
      const windowSize = window.innerHeight;
      const footnotes = document.getElementById('footnoteSection');
      if (footnotes) {
        const footerPosition = footnotes.getBoundingClientRect().top;
        const position = footerPosition / windowSize;
        if (position <= 0.5) {
          this.stickyNav.style.display = 'none';
        } else {
          this.stickyNav.style.display = 'block';
        }
      }
    }, 200));
  }
}
registerModuleClass({
  moduleClass: stickyNavLegacyModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { stickyNavLegacyModule as default, moduleConfig };
